// Group GROUP 20. Pragmatics and Coherence
// Complete data from "Grammar 90 Groups (GPT5) 5 Examples Each.txt"

export const group20Data = {
  "id": "group_20",
  "title": {
    "tc": "語用與連貫",
    "sc": "语用与连贯",
    "en": "Pragmatics and Coherence"
  },
  "subtitle": {
    "tc": "Pragmatics and Coherence",
    "sc": "Pragmatics and Coherence",
    "en": "Pragmatics and Coherence"
  },
  "icon": "💭",
  "difficulty": "advanced",
  "color": "from-gray-500 to-gray-600",
  "topics": [
    {
      "id": "discourse_markers",
      "title": {
        "tc": "語篇標記",
        "sc": "语篇标记",
        "en": "Discourse Markers"
      },
      "description": {
        "tc": "學習語篇標記的用法",
        "sc": "学习语篇标记的用法",
        "en": "Learn discourse marker usage"
      },
      "icon": "📝",
      "difficulty": "advanced",
      "examples": [
        {
          "id": "discourse_1",
          "sentence": "However, the plan was rejected.",
          "analysis": "However (M-discourse), the plan (S) was rejected (V-pass).",
          "translation": {
            "tc": "然而，這個計劃被拒絕了。",
            "sc": "然而，这个计划被拒绝了。",
            "en": "However, the plan was rejected."
          }
        },
        {
          "id": "discourse_2",
          "sentence": "Therefore, we must revise it.",
          "analysis": "Therefore (M-discourse), we (S) must revise (V) it (O).",
          "translation": {
            "tc": "因此，我們必須修改它。",
            "sc": "因此，我们必须修改它。",
            "en": "Therefore, we must revise it."
          }
        },
        {
          "id": "discourse_3",
          "sentence": "Meanwhile, the team prepared.",
          "analysis": "Meanwhile (M), the team (S) prepared (V).",
          "translation": {
            "tc": "與此同時，團隊在準備。",
            "sc": "与此同时，团队在准备。",
            "en": "Meanwhile, the team prepared."
          }
        },
        {
          "id": "discourse_4",
          "sentence": "In contrast, sales fell abroad.",
          "analysis": "In contrast (M), sales (S) fell (V) abroad (M).",
          "translation": {
            "tc": "相比之下，國外銷售下降了。",
            "sc": "相比之下，国外销售下降了。",
            "en": "In contrast, sales fell abroad."
          }
        },
        {
          "id": "discourse_5",
          "sentence": "As a result, we changed course.",
          "analysis": "As a result (M), we (S) changed (V) course (O).",
          "translation": {
            "tc": "結果，我們改變了方向。",
            "sc": "结果，我们改变了方向。",
            "en": "As a result, we changed course."
          }
        }
      ],
      "teachingNotes": {
        "tc": "要點：組織段落邏輯；注意句內/句首標記的逗號用法。",
        "sc": "要点：组织段落逻辑；注意句内/句首标记的逗号用法。",
        "en": "Key points: organize paragraph logic; pay attention to comma usage with intra/sentence-initial markers."
      }
    }
  ]
};
